import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';

import getVidiUrls from 'shared/selectors/vidi-urls';

import VIDEO_PLAYBACK_STATUSES from 'widget/constants/video-playback-status';

import { isVideoPlayRequested, isVideoPauseRequested } from 'widget/selectors/video-playback-status';

import Spinner from 'shared/components/spinner/loading-spinner';
import PlayerAPIFacade from './components/player-api-facade';
import UIWrapper from './components/ui-wrapper';

import {
  setPlaybackStatus,
} from 'widget/redux/client/actions/change-playback-status';

import VideoPlayerWrapper, { Player } from 'video-player-react';

import progressBarStyles from './components/progress-bar.styl';

Player.DefaultControls.ProgressControl.View.extendStyleNames(progressBarStyles);

@connect(
  (state, props) => ({
    isVideoPlayRequested: isVideoPlayRequested(state),
    isVideoPauseRequested: isVideoPauseRequested(state),
    vidiUrls: getVidiUrls(props),
  }),
  {
    setPlaybackStatus,
  }
)
export default class InternalPlayer extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    channelData: React.PropTypes.object,
    videoItem: React.PropTypes.object,

    children: React.PropTypes.any,
    vidiUrls: React.PropTypes.array,
    className: React.PropTypes.string,
    mobileMode: React.PropTypes.bool,
    playAtFullScreen: React.PropTypes.bool,

    width: React.PropTypes.number,
    height: React.PropTypes.number,

    onPlayStart: React.PropTypes.func,
    onResume: React.PropTypes.func,
    onEnded: React.PropTypes.func,

    onError: React.PropTypes.func,
    onSubscribeClick: React.PropTypes.func,
    onPurchaseClick: React.PropTypes.func,
    onFullScreenClicked: React.PropTypes.func,
    onFullScreenChanged: React.PropTypes.func,
    onActionClicked: React.PropTypes.func,

    isVideoPlayRequested: React.PropTypes.bool,
    isVideoPauseRequested: React.PropTypes.bool,

    setPlaybackStatus: React.PropTypes.func,
  };

  static defaultProps = {
    onPlayStart: _.noop,
    onResume: _.noop,
    onEnded: _.noop,

    onError: _.noop,
    onFullScreenClicked: _.noop,
    onFullScreenChanged: _.noop,

    width: 640,
    height: 360,
  };

  componentWillReceiveProps(newProps) {
    this.checkIfNewUrls(newProps);
  }

  //Need to refactor in future
  _beenPlayed = false;

  checkIfNewUrls(newProps) {
    const { vidiUrls } = this.props;
    const { vidiUrls: newVidiUrls } = newProps;

    if (!_.isEqual(vidiUrls, newVidiUrls)) {
      this._beenPlayed = false;
    }
  }

  @autobind
  proxyFullScreenEnter() {
    this.props.onFullScreenChanged(true);
  }

  @autobind
  proxyFullScreenExit() {
    this.props.onFullScreenChanged(false);
  }

  @autobind
  setPlayStatus() {
    const { onPlayStart, onResume, setPlaybackStatus } = this.props;

    if (this._beenPlayed) {
      onResume();
    } else {
      onPlayStart();
      this._beenPlayed = true;
    }

    setPlaybackStatus(VIDEO_PLAYBACK_STATUSES.PLAYING);
  }

  @autobind
  setPauseStatus() {
    const { setPlaybackStatus } = this.props;

    setPlaybackStatus(VIDEO_PLAYBACK_STATUSES.PAUSED);
  }

  @autobind
  setEndStatus() {
    const { setPlaybackStatus, onEnded } = this.props;

    onEnded();
    setPlaybackStatus(VIDEO_PLAYBACK_STATUSES.ENDED);
  }

  get additionalUI() {
    const {
      videoItem,
      channelData,
      appSettings,
      onActionClicked,
      onPurchaseClick,
      onSubscribeClick,
      mobileMode,
    } = this.props;

    if (mobileMode) {
      return null;
    }

    return (
      <PlayerAPIFacade>
        <UIWrapper appSettings={appSettings}
                   videoItem={videoItem}
                   channelData={channelData}
                   mobileMode={mobileMode}
                   onActionClicked={onActionClicked}
                   onPurchaseRequest={onPurchaseClick}
                   onSubscribeRequest={onSubscribeClick} />
      </PlayerAPIFacade>
    );
  }

  get video() {
    const {
      width,
      height,
      vidiUrls,
      isVideoPlayRequested,
      isVideoPauseRequested,
      playAtFullScreen,
      onError,
    } = this.props;

    //TODO: Check preload as API of Wrapper
    return (
      <VideoPlayerWrapper preload="metadata"
                          width={width}
                          height={height}
                          shouldTriggerPlay={isVideoPlayRequested}
                          shouldTriggerPause={isVideoPauseRequested}
                          onError={onError}
                          onPlay={this.setPlayStatus}
                          onPause={this.setPauseStatus}
                          onEnd={this.setEndStatus}
                          onFullScreenEnter={this.proxyFullScreenEnter}
                          onFullScreenExit={this.proxyFullScreenExit}
                          isInFullScreen={playAtFullScreen}
                          src={vidiUrls}>
        {this.additionalUI}
      </VideoPlayerWrapper>
    );
  }

  render() {
    const { vidiUrls } = this.props;

    if (_.isEmpty(vidiUrls)) {
      return <Spinner />;
    }

    return this.video;
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/player-internal.js